import { useState, useEffect } from "react";

/**
 * Hook to monitor network connectivity status
 * @returns {Object} Network status information
 */
export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isSlowConnection, setIsSlowConnection] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      console.log("🌐 Network: Online");
    };

    const handleOffline = () => {
      setIsOnline(false);
      console.log("🌐 Network: Offline");
    };

    // Listen for online/offline events
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Check connection quality if available
    const checkConnectionQuality = () => {
      if ("connection" in navigator) {
        const connection = navigator.connection;
        const isSlow =
          connection.effectiveType === "slow-2g" ||
          connection.effectiveType === "2g" ||
          connection.downlink < 1;
        setIsSlowConnection(isSlow);
      }
    };

    // Initial check
    checkConnectionQuality();

    // Listen for connection changes
    if ("connection" in navigator) {
      navigator.connection.addEventListener("change", checkConnectionQuality);
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      if ("connection" in navigator) {
        navigator.connection.removeEventListener(
          "change",
          checkConnectionQuality
        );
      }
    };
  }, []);

  return {
    isOnline,
    isOffline: !isOnline,
    isSlowConnection,
    connectionType: navigator.connection?.effectiveType || "unknown",
  };
};

export default useNetworkStatus;
